window.toggleAccordion = function (accordionHeader) {
    const accordionContainer = accordionHeader.parentNode.querySelector(".accordion-container");
    if (accordionContainer) {
        accordionContainer.classList.toggle('accordion-container--closed');
    }
};
window.closeModal = function (elem) {
    elem.closest('.modal-wrapper').classList.add('modal-wrapper--hidden');
}
window.submitModal = function () {
    if (!!window.modalCallback) {
        window.modalCallback(window.modalData);
    }
}
window.openModal = function (data, title, body, callback) {
    document.querySelector('#modal .modal-header-title').innerHTML = title;
    document.querySelector('#modal .modal-body').innerHTML = body;
    window.modalData = data;
    window.modalCallback = callback;
    const modal = document.getElementById('modal');
    modal.className = modal.className.replace("modal-wrapper--hidden", "");
}
window.openNearStoreModal = function (data) {
    document.querySelector('#modal-near-store .modal-header-title').innerHTML = "Punti vendita Novellini nella tua zona";
    const singleStoreTemplate = document.querySelector('#single-store-template').innerHTML;
    let stores = '';
    data.forEach(function(singleStore) {
        stores += singleStoreTemplate
            .replace("{{name}}", singleStore.name)
            .replace("{{address}}", singleStore.address)
            .replace("{{city}}", singleStore.city)
            .replace("{{phone}}", singleStore.phone)
            .replace("{{latitude}}", singleStore.latitude)
            .replace("{{longitude}}", singleStore.longitude);
    });
    document.querySelector('#modal-near-store .modal-body .stores-container').innerHTML = stores;
    const modal = document.getElementById('modal-near-store');
    modal.className = modal.className.replace("modal-wrapper--hidden", "");
}
/*window.onSubmit = function (token) {
    const data = Object.fromEntries(new FormData(document.getElementById("form")).entries());
    if (validateForm(data)) {
        axios({
            method: 'post', url: 'https://fh3b7ac572.execute-api.eu-west-1.amazonaws.com/Prod/', data: data
        }).then(response => {
            openModal(null, "Grazie!", "Il form è stato inviato con successo.", null)
        }).catch(error => {
            openModal(null, "Attenzione!", error.response.data.error, null)
        })
    } else {
        openModal(null, "Attenzione!", "Per favore ricontrolla i dati inseriti.", null);
    }
}*/
window.onSubmit = function (token) {
    const data = Object.fromEntries(new FormData(document.getElementById("form")).entries());
    if (validateForm(data)) {
        const dataToSend = {
            "Firstname": data['nome'],
            "Lastname": data['cognome'],
            "Email": data['email'],
            "Phone": data['telefono'],
            "Zipcode": data['cap'],
            "ProvinceState": data['provincia'],
            /*"CampaignId": "116",*/
            "CampaignId": "8",
            "Grecaptcha": data['g-recaptcha-response']
        };
        const loader = document.getElementById('ada-loading');
        loader.className += " ada-loading--visible";
        axios({
            /*method: 'post', url: 'https://staging.novellini.it/leads/API/Lead/CampagnaADVFinanziamento', data: dataToSend*/
            method: 'post', url: 'https://crm2.novellini.com/leads/api/lead/campagnaadvfinanziamento', data: dataToSend
        }).then(response => {
            loader.className = loader.className.replace("ada-loading--visible", "");
            if (response.data && response.data.result && response.data.result === "success") {
                if (response.data.data && response.data.data.length) {
                    openNearStoreModal(response.data.data);
                    dataLayer.push({event: 'form-storelocator-ok'});
                }
                else {
                    openModal(null, "Grazie!", "Il form è stato inviato con successo e abbiamo registrato la tua richiesta.", null)
                    dataLayer.push({event: 'form-storelocator-ok'});
                }
            }
            else {
                openModal(null, "Attenzione!", "Qualcosa è andato storto, riprova più tardi.", null)
            }
        }).catch(error => {
            console.error(error);
            openModal(null, "Attenzione!", "Qualcosa è andato storto, riprova più tardi.", null)
        })
    } else {
        openModal(null, "Attenzione!", "Per favore ricontrolla i dati inseriti.", null);
    }
}

function validateForm(data) {
    // Get form inputs
    var phoneNumber = data.telefono;
    var email = data.email;

    // Regular expressions for phone number and email validation
    // var phoneRegex = /^\d{10}$/; // Matches 10 digits
    var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Matches valid email format

    var isValid = true;

    // // Check if phone number is valid
    // if (!phoneRegex.test(phoneNumber)) {
    //   alert('Please enter a valid phone number');
    //   pointOutInvalidField("telefono");
    //   isValid = false; // Prevent form submission
    // } else {
    //   let phoneNumber = document.querySelector('input[name="telefono"]');
    //   if (phoneNumber && phoneNumber.classList.contains('invalidFormField')) {
    //     phoneNumber.classList.remove('invalidFormField');
    //   }
    // }

    // Check if email is valid
    if (!emailRegex.test(email)) {
        pointOutInvalidField("email");
        // alert('Please enter a valid email address');
        isValid = false; // Prevent form submission
    } else {
        let email = document.querySelector('input[name="email"]');
        if (email && email.classList.contains('invalidFormField')) {
            email.classList.remove('invalidFormField');
        }
    }

    let checkbox = document.querySelector('.checkbox .labels');
    if (!data.hasOwnProperty("privacy")) {
        if (checkbox && !checkbox.classList.contains('invalidFormField')) {
            checkbox.classList.add('invalidFormField')
        }
        isValid = false;
    } else {
        if (checkbox && checkbox.classList.contains('invalidFormField')) {
            checkbox.classList.remove('invalidFormField');
        }
    }

    // Check if data fields are not empty
    for (let field in data) {
        if (data.hasOwnProperty(field) && data[field].trim() === '') {
            // alert('Please fill in all data fields', field);
            pointOutInvalidField(field);
            isValid = false; // Prevent form submission
        } else {
            let formField = document.querySelector('input[name="' + field + '"]');
            if (formField && formField.classList.contains('invalidFormField')) {
                formField.classList.remove('invalidFormField');
            }
        }
    }
    return isValid;
}

function pointOutInvalidField(field) {
    let invalidField = document.querySelector('input[name="' + field + '"]');
    if (invalidField && !invalidField.classList.contains('invalidFormField')) {
        invalidField.classList.add('invalidFormField')
    }
}
